/**
 * @directive sgHelp
 * @param {String} key - Contains the actual json message.
 * @param {String} position - Used to position the icon (left/right). 
 *                            By default it's set to 'left'.
 * */

(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgHelp', sgHelp);

  sgHelp.$inject = [];

  function sgHelp () {

    return {
      templateUrl: 'app-legacy/components/sg-help/sg-help.html',
      transclude: true,
      restrict: 'E',
      scope: {
        key: '@', 
        position: '@',
      },
      bindToController: true,
      controllerAs: 'helpCtrl',
      controller: 'sgHelpController'
    };
  }

})();
